<template>
  <AppAddItemButtonBase :itemTypeID="itemType">
    <template slot="title">
      Add Service
    </template>
    <template slot="itemInputField" slot-scope="props">
      <v-text-field
        placeholder="Service name"
        v-model="props.model.name"
      ></v-text-field>
    </template>
  </AppAddItemButtonBase>
</template>

<script>
  import AppAddItemButtonBase from '@/components/AppAddItemButtonBase'
  import itemTypesMixins from '@/mixins/ItemTypes'

  export default {
    components: { AppAddItemButtonBase },
    mixins: [ itemTypesMixins ],
    data () {
      return {
        resources: 'services'
      }
    },
    computed: {
      itemType () {
        return this.serviceTypeID
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddServiceButton.vue?67a5b1dc